




































import {
  Component, mapState, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import AddCampaignGroup from './AddCampaignGroup.vue';
import {
  CampaignStore, CommonsStore, Payload, AuthorizationStore,
} from '@samclick-store-factory';
import { sortString } from '@/utils/common-utils';
import { _filter, _includes } from '@samclick-lodash';

const tag = new Map([
  ['1', 'success'],
  ['2', 'danger'],
]);

class CampaignGroupTabState {
 search: string = ''
}

@Component({
  /**
   * Imported components
   * */
  components: { AddCampaignGroup },
  /**
   * Stores values
   * */
  computed: {
    ...mapState({
      campaignStatus: (state: any) => state.commons.commonsStore.campaignStatus,
      campaignGroup: (state: any) => state.commons.commonsStore.campaignGroup,
    }),
  },
  /**
   * Component properties
   * */
  props: {},
})
export default class CampaignGroupTab extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
    state = new CampaignGroupTabState();

  /**
   * Watchers
   * */
  @Watch('componentState.var')
    sampleWatcher(newVal: string, oldVal: string) {

    }

  /**
   * Methods
   * */
  addCampaignGroup(row: object = {}) {
    this.$refs.campaignGroup.toggleDialog(true, row);
  }

  loadCampaignGroups() {
    CommonsStore.getCampaignGroups(new Payload({ affiliateId: AuthorizationStore.currentLoggedUserInState.id }));
  }

  getTagType(status: number) {
    return tag.get(status.toString());
  }

  getCampaignStatusDescription(status: number) {
    return CommonsStore.campaignStatus(status).label;
  }

  sortByStatus(a: any, b: any) {
    return sortString(this.getCampaignStatusDescription(a.status), this.getCampaignStatusDescription(b.status));
  }

  /**
   * Computed
   * */
  get campaignGroupList() {
    const { search } = this.state;
    return _filter(this.campaignGroup, o => _includes(o.description.toLocaleLowerCase(), search.toLocaleLowerCase())
          || _includes(o.name.toLocaleLowerCase(), search.toLocaleLowerCase())
          || _includes(o.id.toString(), search)
          || _includes(o.status === 1 ? this.$t('lookups.campaign_status_active').toString().toLocaleLowerCase() : this.$t('lookups.campaign_status_inactive').toString().toLocaleLowerCase(), search.toLocaleLowerCase()));
  }

  /**
   * Lifecycle hooks
   * */
  created() {}

  mounted() {}

  beforeUpdate() {}
}
